import __request__ from "routing/request";
export function list() {
  return __request__("GET", "/cluster/jobs", null, {}, {
    "Accept": ["application/json"]
  });
}
export function getJob(jobId) {
  return __request__("GET", `/cluster/jobs/${jobId}`, null, {}, {
    "Accept": ["application/json"]
  });
}
export function cancelJob(jobId) {
  return __request__("DELETE", `/cluster/jobs/${jobId}`, null, {}, {
    "Accept": ["application/json"]
  });
}
